import { Routes } from '@angular/router';
import { AuthGuard } from 'app/authentication/guard/auth.guard';

import { ContactPage } from './components/contact-page/contact-page.component';
import { ContactsListPageComponent } from './components/contacts-list-page/contacts-list-page.component';

export const ContactsRoutes: Routes = [
	{
		path: 'contacts',
		component: ContactsListPageComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'contact/:contactId',
		component: ContactPage,
		canActivate: [AuthGuard],
	},
	{
		path: 'contact/:contactId/:tabPath',
		component: ContactPage,
		canActivate: [AuthGuard],
	},
];
